const dataRoadMap = [
  {
    id: 1,
    time: "Jan 2026 - Present",
    title: "Stealth Startup (Software Engineer)",
    desc: "Building innovative products from the ground up at an early-stage stealth startup. Driving full-stack development and shaping the core product architecture.",
    class: "",
  },
  {
    id: 2,
    time: "Nov 2023 - Dec 2025",
    title: "Datasirpi (Software Engineer)",
    desc: "Spearheaded development of 6+ enterprise-level applications with 95% client satisfaction. Reduced development time by 30% and mentored 4 junior developers, improving team productivity by 25%.",
    class: "right",
  },
  {
    id: 3,
    time: "May 2020 - Nov 2023",
    title: "Wolphix (Freelance Developer)",
    desc: "Designed and developed comprehensive school management system improving administrative efficiency by 40%. Created 15+ responsive landing pages and increased client conversion rates by 35%.",
    class: "",
  },
  {
    id: 4,
    time: "Feb 2017 - May 2020",
    title: "Graphic Designer",
    desc: "Designed logos, marketing materials and social media content for 25+ clients. Specialized in minimalist branding and UI/UX design. Average client satisfaction rate of 98%.",
    class: "right",
  },

  //   {
  //     id: 4,
  //     time: "February 01, 2022",
  //     title: "Result & Final Report",
  //     desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis diam enim, scelerisque sit amet diam ut, molestie ultrices nisi. Suspendisse in ipsum ante. Ut rhoncus ligula dictum gravida.",
  //     class: "right",
  //   },
  //   {
  //     id: 5,
  //     time: "February 01, 2022",
  //     title: "Design & Development",
  //     desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis diam enim, scelerisque sit amet diam ut, molestie ultrices nisi. Suspendisse in ipsum ante. Ut rhoncus ligula dictum gravida.",
  //     class: "",
  //   },
];

export default dataRoadMap;
